import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { justForSideEffect, justForSideEffectWithPayload } from 'src/infrastructure/saga.helpers'
import {
  InvalidStructureDetails,
  SalesChannel,
  SelectedSalesChannel,
  StockAddressing,
  StockAddressingInBatchState,
  SubmitFileValues,
} from './StockAddressingInBatchTypes'

const initialState: StockAddressingInBatchState = {
  uploadFilePage: {
    salesChannelsByFC: [],
    selectedSalesChannels: [],
  },
}

const submitStockAddressingFile = justForSideEffectWithPayload<SubmitFileValues>()
const getSalesChannelsByFC = justForSideEffectWithPayload<number>()

const addSelectedSalesChannel = (
  state: StockAddressingInBatchState,
  action: PayloadAction<SelectedSalesChannel>,
): StockAddressingInBatchState => ({
  ...state,
  uploadFilePage: {
    ...state.uploadFilePage,
    selectedSalesChannels: [
      ...state.uploadFilePage.selectedSalesChannels || [],
      action.payload,
    ],
  },
})

const setStockAddressingFile = (
  state: StockAddressingInBatchState,
  action: PayloadAction<File | undefined>,
): StockAddressingInBatchState => ({
  ...state,
  uploadFilePage: {
    ...state.uploadFilePage,
    stockAddressingFile: action.payload,
  },
})

const downloadAddressingResultFile = justForSideEffect()

const setStockAddressingResult = (
  state: StockAddressingInBatchState,
  action: PayloadAction<StockAddressing>,
): StockAddressingInBatchState => ({
  ...state,
  uploadFilePage: {
    ...state.uploadFilePage,
    stockAddressing: action.payload,
  },
})

const setSalesChannelsByFC = (
  state: StockAddressingInBatchState,
  action: PayloadAction<SalesChannel[]>,
): StockAddressingInBatchState => ({
  ...state,
  uploadFilePage: {
    ...state.uploadFilePage,
    salesChannelsByFC: action.payload,
  },
})

const setFileInvalidStructure = (
  state: StockAddressingInBatchState,
  action: PayloadAction<InvalidStructureDetails>,
): StockAddressingInBatchState => ({
  ...state,
  uploadFilePage: {
    ...state.uploadFilePage,
    invalidStructure: action.payload,
  },
})

const resetUploadPage = (
  state: StockAddressingInBatchState,
): StockAddressingInBatchState => ({
  ...state,
  uploadFilePage: initialState.uploadFilePage,
})

const slice = createSlice({
  name: 'stockAddressingInBatch',
  initialState,
  reducers: {
    addSelectedSalesChannel,
    getSalesChannelsByFC,
    resetUploadPage,
    setFileInvalidStructure,
    setSalesChannelsByFC,
    setStockAddressingFile,
    setStockAddressingResult,
    submitStockAddressingFile,
    downloadAddressingResultFile,
  },
})

export default slice.reducer

export const { actions } = slice
